<template>
  <div class="news-container">
    <div class="news-table clearfix">
      <div class="news-title">{{title}}</div>
      <div class="news-time">发布时间：{{sendTime}}</div>
      <div class="news-content" v-html="content">
      </div>
    </div>
  </div>
</template>

<script>
  import {ApiGetMsgDetail} from '../../net/home/index.js'
export default {
  data: function () {
    return {
      content: '',
      sendTime:'',
      title:''
    }
  },
  methods:{
    getDetail: function () {
      ApiGetMsgDetail({id: this.$route.params.id}).then(res=>{
        if (res.code == 200) {
          this.content = res.value.content
          this.sendTime = res.value.sendTime
          this.title = res.value.title
        }
      })
    }
  },
  mounted: function () {
    this.getDetail()
  }
}
</script>

<style scoped>
.news-container{
  width: 1140px;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 20px;
  background:#fff;
  min-height: 600px;
  border-radius: 6px;
}
.news-table{
  width: 860px;
  margin:0 auto;
}
.news-title{
  font-size:24px;
  text-align: center;
  width: 100%;
  float: left;
  margin-top: 50px;
  color: #333;
}
.news-time{
  font-size: 16px;
  text-align: center;
  color: #7f7f7f;
  width: 100%;
  float: left;
  margin-top: 16px;
}
.news-content{
  width: 900px;
  margin-top: 30px;
  margin-bottom: 30px;
  float: left;
  color: #333;
  line-height: 1.8;
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/News/News.vue